export enum replyStates {
	new = 'new',
	seen = 'seen',
	closedAssigned = 'assigned',
	closedAddedToCampagin = 'addedToCampaign',
	closedNoResponse = 'closed',
}
